/**
 * @file ElementFile.jsx
 * @author Daniel Aguirre
 * @description ElementFile Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import {
  ArrowRightOutlined,
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

// Helper
import { getStorageItem } from 'commons/helpers/storage-helper';

// Components
import PanelItem from '../panelItem';

function ElementFile({
  name,
  link,
  linkParam,
  icon,
  date,
  onEditFunc,
  onDeleteFunc,
  permissions
}) {
  const [isPatient, setIsPatient] = React.useState(false);
  const { t: translate } = useTranslation();
  const history = useHistory();

  React.useEffect(async () => {
    setIsPatient(await getStorageItem('isPatient'));
  }, []);

  const body = (
    <div>
      <span className="text-base text-baxterGray font-bold">{name}</span>
      <p className="p-0 m-0 text-placeholder" style={{ fontSize: 12 }}>
        {date}
      </p>
    </div>
  );

  const options = isPatient ? (
    <div>
      <ArrowRightOutlined
        className="float-right"
        style={{
          fontSize: 16,
          color: 'var(--color-place-holder)',
          textAlign: 'right'
        }}
      />
    </div>
  ) : (
    <div className="">
      <Popconfirm
        title={translate('¿Estás seguro de eliminar este elemento?')}
        cancelText={translate('commons.cancel')}
        okText={translate('commons.confirm')}
        onConfirm={onDeleteFunc}
        icon={<QuestionCircleOutlined style={{ color: '#FA7268' }} />}>
        {permissions.delete && (
          <DeleteOutlined
            className="float-right"
            style={{
              fontSize: 16,
              color: 'var(--color-error)'
            }}
          />
        )}
      </Popconfirm>
      {permissions.update && (
        <EditOutlined
          onClick={onEditFunc}
          className="float-right mr-3"
          style={{
            fontSize: 16,
            color: 'var(--color-place-holder)'
          }}
        />
      )}
    </div>
  );

  return !isPatient ? (
    <PanelItem
      onClick={() => history.push(link, linkParam)}
      icon={icon}
      body={body}
      options={options}
    />
  ) : (
    <PanelItem
      allClickable={true}
      fullOnClick={() => history.push(link, linkParam)}
      icon={icon}
      body={body}
      options={options}
    />
  );
}

/**
 * Component definition of proptypes.
 */
ElementFile.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  date: PropTypes.string.isRequired,
  onEditFunc: PropTypes.func,
  onDeleteFunc: PropTypes.func,
  categoryData: PropTypes.object,
  linkParam: PropTypes.any,
  permissions: PropTypes.object
};
export default ElementFile;
